import canUseDOM from 'lib/util/canUseDOM';

export const canUsePerformance = canUseDOM && typeof window.performance !== 'undefined';
const perfDebug = canUseDOM && window.location.search.indexOf('perf_debug=true') > -1;
const perfEnabled = canUsePerformance && perfDebug;
const logMark = perfEnabled && window.location.search.indexOf('perf_mark_log=true') > -1;

export function mark(name) {
    if (!perfEnabled) {
        return;
    }
    window.performance.mark(name);
}

export function markStart(name) {
    if (logMark) {
        console.log(`perf: mark '${name}'`);
    }
    mark(`${name}_start`);
}

export function markEnd(name) {
    mark(`${name}_end`);
}

export function clear(name) {
    if (!perfEnabled) {
        return;
    }
    const startMark = `${name}_start`;
    const endMark = `${name}_end`;
    window.performance.clearMarks(startMark);
    window.performance.clearMarks(endMark);
    window.performance.clearMeasures(name);
}

export function measure(name, startMarkArg, endMarkArg) {
    if (!perfEnabled) {
        return;
    }
    const startMark = startMarkArg || `${name}_start`;
    const endMark = endMarkArg || `${name}_end`;
    const [entry] = window.performance.getEntriesByName(endMark);
    if (!entry) {
        mark(endMark);
    }
    try {
        window.performance.measure(name, startMark, endMark);
    } catch (err) {}
}

export function measureAndTime(name, startMark, endMark) {
    measure(name, startMark, endMark);
    time(name);
    clear(name);
}

export function time(name, all = false, print = true) {
    if (!perfEnabled) {
        return;
    }
    let entries;
    if (name) {
        entries = window.performance.getEntriesByName(name);
    } else {
        entries = window.performance.getEntriesByType('measure');
    }
    if (!all) {
        entries = entries[0];
        if (print) {
            console.log(`perf: measure '${name}'`, entries);
        }
    } else if (print) {
        entries.forEach(entry => {
            console.log(`perf: measure '${entry.name}'`, entry);
        });
    }
    return entries;
}



// WEBPACK FOOTER //
// ./app/lib/util/perf.js